import { Alert, Breadcrumb, Button, Col, DatePicker, Drawer, Empty, Flex, Form, Input, Layout, Popconfirm, Row, Select, Space, Table, Tabs, Tag, theme } from 'antd';
import { FilterOutlined, FileWordOutlined, DeleteOutlined, FileOutlined, FieldTimeOutlined, FileExclamationOutlined, EyeOutlined, EditOutlined, FileSyncOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react'
import { DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import FilterComponent from '../../../utils/FilterComponent';
import {
    arrayMove,
    SortableContext,
    useSortable,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Inprogress from './Inprogress';
import Archived from './Archived';
import ToDo from './ToDo';
import WorkflowManagementAPI from '../../../restAPI/WorkflowManagementAPI';
import Draft from './Draft';
//import Todo from './Todo';


const { Search, TextArea } = Input;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Header, Footer, Sider, Content } = Layout;


export default function Circulation({ props }) {

    const [activeKey, setActiveKey] = useState('1');
    const [tabValue, setTabValue] = useState(1);
    const [value, setValue] = useState('');
    const [archivedDrawerVisibility, setArchivedDrawerVisibility] = useState("");
    //console.log(tempArchivedData)

    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();
    const [openFilter, setOpenFilter] = useState(false);

    const onClickFilterIcon = () => {
        setArchivedDrawerVisibility(true)
    }

    const handleChangeArchivedState = (newData) => {
        setArchivedDrawerVisibility(false)
    };

    const items = [
        {
            key: '1',
            label: 'To Do',
            //children: <ToDo tabValue={tabValue} />,
            children: tabValue === 1 ? <ToDo tabValue={tabValue} searchText={value} /> : '',
            icon: <FieldTimeOutlined />

        },
        {
            key: '2',
            label: 'In Progress',
            //children: <Inprogress tabValue={tabValue} searchText={value}/>,
            children: tabValue === 2 ? <Inprogress tabValue={tabValue} searchText={value} /> : '',
            icon: <FieldTimeOutlined />
        },
        {
            key: '3',
            label: 'Archived',
            //children: <Archived tabValue={tabValue} searchText={value}/>,
            // children: tabValue === 3 ? <Archived tabValue={tabValue} searchText={value} onChildValueChange={handleChildValueChange}/> : '',
            children: tabValue === 3 ? <Archived tabValue={tabValue} searchText={value} archivedDrawer={archivedDrawerVisibility} onChangeState={handleChangeArchivedState} /> : '',
            icon: <FileExclamationOutlined />,
        },
        {
            key: '4',
            label: 'Draft',
            //children: <Draft tabValue={tabValue} searchText={value}/>,
            children: tabValue === 4 ? <Draft tabValue={tabValue} searchText={value} /> : '',
            icon: <FileOutlined />
        },
    ];

    const handleTabChange = (key) => {
        setValue('')
        setActiveKey(key);

        if (key === '1') {
            setTabValue(1);
        } else if (key === '2') {
            setTabValue(2);
        } else if (key === '3') {
            setTabValue(3);
        } else if (key === '4') {
            setTabValue(4);
        }
    };

    const handleChange = (e) => {
        setValue(e.target.value);
    };

    return (
        <>
            <Flex gap={20} justify='space-between' align='center' style={{
                margin: '16px',
                padding: '16px 24px',
                // minHeight: 280,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Breadcrumb
                    items={[
                        {
                            href: '',
                            title: <FileWordOutlined />,
                        },
                        {
                            title: 'Workflow',
                        },
                        {
                            title: 'Circulation',
                        },
                    ]}
                />

                <Flex justify='center' align='center' gap={48}>
                    <Flex justify='center' align='center' gap={12}>
                        <Button
                            type='default'
                            icon={<FilterOutlined style={{ paddingLeft: 8, paddingRight: 8 }} />}
                            style={{ display: activeKey == 3 ? 'inline-block' : 'none' }}
                            onClick={onClickFilterIcon}
                        />
                        <Search placeholder="Search"
                        onChange={(e) => handleChange(e)} value={value}
                             />
                    </Flex>
                </Flex>
            </Flex>

            <div style={{
                margin: '16px',
            }}>
                { }
            </div>

            <div style={{
                margin: '16px',
                padding: 24,
                minHeight: "78svh",
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Tabs
                    //defaultActiveKey="1" 
                    items={items}
                    key={1}
                    //onChange={onChange} 
                    activeKey={activeKey}
                    onChange={handleTabChange}
                />
            </div>
        </>
    )
}